<button
  type="button"
  class="dropdown-toggle dropdown-toggle-split"
  data-toggle="dropdown"
  aria-haspopup="true"
  aria-expanded="false"
>
  {{ selectedItemName }}
</button>

<div class="dropdown-menu">
  @for (item of items(); track $index) {
  <span
    class="dropdown-item"
    [class.active-item]="item.isSelected"
    (click)="onItemSelected(item)"
    (keypress)="onItemSelected(item)"
    tabindex="0"
    >{{ item.Name }}</span
  >
  }
</div>
